import * as yup from 'yup';
import i18n from '../../../../../../i18n';
import { ALL_SESSION_VLANS_VALUE } from '../../../components/VirtualMachineEntities/Configure/Utils';

export const editValidationSchema = (
  takenNames: string[],
): yup.SchemaOf<Pick<Hardware, 'name'>> =>
  yup.object().shape({
    name: yup
      .string()
      .required(i18n.t('hardware.edit.nameRequiredError'))
      .max(255, i18n.t('hardware.edit.nameMaxLengthError'))
      .notOneOf(takenNames, i18n.t('hardware.edit.uniqueNameError')),
  });

export interface AddNetworkFormData {
  interface: string;
  network?: string;
  trunked?: boolean;
  trunkedNetworks?: string[];
}

export const addNetworkValidationSchema =
  (): yup.SchemaOf<AddNetworkFormData> =>
    yup.object().shape({
      interface: yup
        .string()
        .required(i18n.t('common.pleaseSelect')),
      network: yup.string().when('trunked', {
        is: true,
        otherwise: yup
          .string()
          .required(
            i18n.t('networks.trunk.formErrors.networkName'),
          ),
        then: yup.string().notRequired(),
      }),
      trunked: yup.boolean(),
      trunkedNetworks: yup.array().when('trunked', {
        is: true,
        otherwise: yup.array().notRequired(),
        then: yup
          .array()
          .of(yup.string())
          .min(
            1,
            i18n.t(
              'networks.trunk.formErrors.trunkedNetworksRequired',
            ),
          )
          .test(
            'all-session-vlans-exclusive',
            i18n.t(
              'networks.trunk.formErrors.trunkedNetworksExclusive',
            ),
            (value) => {
              if (!value?.includes(ALL_SESSION_VLANS_VALUE)) {
                return true;
              }

              return value.length === 1;
            },
          ),
      }),
    });
